import {
  IconButton as MuiIconButton,
  type IconButtonProps,
  type PropTypes,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

interface IIconButtonProps extends IconButtonProps {
  backgroundColor?: PropTypes.Color;
  href?: string;
}

const useStyles = makeStyles((theme) => ({
  default: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: theme.palette.background.paper,
    },
  },
  defaultStroke: {
    border: `1px solid ${theme.palette.text.primary}`,
  },
  inherit: {
    backgroundColor: 'inherit',
  },
  inheritStroke: {
    border: `1px solid currentColor`,
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  primaryStroke: {
    border: `1px solid ${theme.palette.primary.contrastText}`,
  },
  secondary: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  secondaryStroke: {
    border: `1px solid ${theme.palette.secondary.contrastText}`,
  },
}));

export const IconButton = ({
  backgroundColor,
  children,
  className,
  ...props
}: IIconButtonProps) => {
  const styles = useStyles();
  const color = props.color
    ? props.color
    : backgroundColor
      ? 'inherit'
      : 'default';

  return (
    <MuiIconButton
      className={clsx(
        'on3-icon-button',
        className,
        backgroundColor && styles[backgroundColor],
      )}
      color={color}
      {...props}
    >
      {children}
    </MuiIconButton>
  );
};

export default IconButton;
